import { AppNavigationMenuItem, UserNavigationMenuItem, UserNavigationMenuContext } from "./navigation-menu.models";
import { hasPageAccess } from "../access-control/access-control";

function isMenuItemAvailableToUser(
    appNavigationMenuItem: AppNavigationMenuItem,
    userNavigationMenuContext: UserNavigationMenuContext,
): boolean {
    return (
        hasPageAccess({ requirements: appNavigationMenuItem.accessControl, context: userNavigationMenuContext }) &&
        (appNavigationMenuItem.visibleWhen?.(userNavigationMenuContext) ?? true)
    );
}

// Menu children are leaf items, so they cannot have nested children.
function buildUserNavigationMenuItem(
    appNavigationMenuItem: AppNavigationMenuItem,
): UserNavigationMenuItem["children"][number] {
    return {
        id: appNavigationMenuItem.id,
        label: appNavigationMenuItem.label,
        route: appNavigationMenuItem.route,
        icon: appNavigationMenuItem.icon,
        activeState: appNavigationMenuItem.activeState,
        children: [],
    };
}

export function buildUserNavigationMenu(
    appNavigationMenu: readonly AppNavigationMenuItem[],
    userNavigationMenuContext: UserNavigationMenuContext,
): readonly UserNavigationMenuItem[] {
    return appNavigationMenu.flatMap((appNavigationMenuItem) => {
        if (!isMenuItemAvailableToUser(appNavigationMenuItem, userNavigationMenuContext)) {
            return [];
        }

        // Children may be static or generated from the users context (for example, reports).
        const children =
            typeof appNavigationMenuItem.children === "function"
                ? appNavigationMenuItem.children(userNavigationMenuContext)
                : appNavigationMenuItem.children;

        return [
            {
                ...buildUserNavigationMenuItem(appNavigationMenuItem),
                children: (children ?? [])
                    .filter((child) => isMenuItemAvailableToUser(child, userNavigationMenuContext))
                    .map(buildUserNavigationMenuItem),
            },
        ];
    });
}
